// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataQualityRulesTableScd2
 */
export interface DataQualityRulesTableScd2 {
    /**
     * 
     * @type {boolean}
     * @memberof DataQualityRulesTableScd2
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the DataQualityRulesTableScd2 interface.
 */
export function instanceOfDataQualityRulesTableScd2(value: object): value is DataQualityRulesTableScd2 {
    return true;
}

export function DataQualityRulesTableScd2FromJSON(json: any): DataQualityRulesTableScd2 {
    return DataQualityRulesTableScd2FromJSONTyped(json, false);
}

export function DataQualityRulesTableScd2FromJSONTyped(json: any, ignoreDiscriminator: boolean): DataQualityRulesTableScd2 {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function DataQualityRulesTableScd2ToJSON(json: any): DataQualityRulesTableScd2 {
    return DataQualityRulesTableScd2ToJSONTyped(json, false);
}

export function DataQualityRulesTableScd2ToJSONTyped(value?: DataQualityRulesTableScd2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}
